import { Component, OnInit, OnDestroy } from '@angular/core';
import * as Highcharts from 'highcharts';
import { AnimationOptions } from 'ngx-lottie';
import { Subscription } from 'rxjs';
import { DataService } from '../core/services/data-service.service';
import { fadeInAnimation } from '../animations';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  animations: [fadeInAnimation],
})
export class MainComponent implements OnInit, OnDestroy {
  splashImg: string = `assets/${environment.project}/splashIcon.svg`;
  
  dataSub: Subscription;
  blockToShow: string;
  hasData: boolean = false;

  constructor(private dataService: DataService, private route: ActivatedRoute) {
    this.dataService.start();
  }

  options: AnimationOptions = {
    path: 'assets/json/loading.json',
  };

  styles: Partial<CSSStyleDeclaration> = {
    maxWidth: '500px',
  };

  ngOnInit(): void {
    if (this.route.snapshot.data['blockToShow']) {
      this.blockToShow = this.route.snapshot.data['blockToShow'];
    }

    this.dataSub = this.dataService.windAtmosphereData$.subscribe(
      widget => { this.hasData = widget.charts.yAxis.length > 0 || widget.lastValues.length > 0 || widget.tables.length > 0 }
    );

    this.setHighchartsOptions();
  }

  ngOnDestroy(): void {
    if (this.dataSub) this.dataSub.unsubscribe();
  }

  setHighchartsOptions() {
    Highcharts.setOptions({
      lang: {
        resetZoom: 'Zoom Inicial',
        shortMonths: [
          'Jan', 'Fev', 'Mar', 'Abr', 'Mai','Jun',
          'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
        ],
        weekdays: [
          'Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira',
          'Quinta-feira', 'Sexta-feira', 'Sábado'
        ],
        numericSymbols: null,
        rangeSelectorFrom: 'De ',
        rangeSelectorTo: 'Até ',
      },
    });
  }
}
